<footer [ngClass]="{ 'd-flex flex-row mt-4': true, 'bg-primary': isProduction, 'dev-marker': !isProduction }">
  <p class='text-light py-3 h5'>© HKA-APP {{ Date() | date: 'YYYY' }}</p>
</footer>
